// React
import { useState } from 'react';

// Listing
export default function useListing(initialSort, initialFilters = {}, endpoint = null) {
  // Filters
  // check if the current endpoint has savedFilters. If the endpoint has changed, delete it.
  let filtersToApply = initialFilters;

  let savedFilters = window.localStorage.getItem('savedFilters');
  if (endpoint != null && savedFilters) {
    savedFilters = JSON.parse(savedFilters);
    if (savedFilters.endpoint === endpoint) {
      filtersToApply = savedFilters.activeFilters;
    } else {
      // if the endpoint is different, saved filters should be deleted (as per request's user journey TW#23829577)
      window.localStorage.removeItem('savedFilters');
    }
  }

  const [activeFilters, setActiveFilters] = useState(filtersToApply);

  // Save filters
  const saveActiveFilters = (newActiveFilters) => {
    setActiveFilters(newActiveFilters);
  };

  // Page
  const [page, setPage] = useState(0); // DataGrid starts at page 0, WebService starts at page 1

  // Page Size
  const [pageSize, setPageSize] = useState(25);

  // Sort
  const [sortModel, setSortModel] = useState([initialSort]);

  // Reset sort
  const resetSortModel = () => {
    setSortModel([initialSort]);
  };

  // Selection
  const [selectionModel, setSelectionModel] = useState([]);

  // Flag to refresh the data table/grid
  const [refreshDataGrid, setRefreshDataGrid] = useState(true);

  // Export modal filters
  const [activeExportFilters, setActiveExportFilters] = useState(initialFilters);
  const saveActiveExportFilters = (newActiveExportFilters) => {
    setActiveExportFilters(newActiveExportFilters);
  };

  return {
    activeFilters,
    saveActiveFilters: saveActiveFilters,
    page,
    pageSize,
    setPage: setPage,
    setPageSize : setPageSize,
    sortModel,
    setSortModel: setSortModel,
    resetSortModel: resetSortModel,
    selectionModel,
    setSelectionModel: setSelectionModel,
    refreshDataGrid,
    setRefreshDataGrid: setRefreshDataGrid,
    activeExportFilters,
    saveActiveExportFilters: saveActiveExportFilters
  };
}
